export default "https://assets-v2.scaler.com/packs/images/powerIcon.9a0105.svg";